import React, { useState } from 'react'
import { useHistory } from 'react-router-dom'
import Select from 'react-select';

export const AddCrm = () => {
    
    // const [countryList, setCountryList] = useState([])
    // const [countryValue, setCountryValue] = useState('')
    // const [cityList, setCityList] = useState([])
    // const [cityValue, setCityValue] = useState('')
    // const [loader, setLoader] = useState(true)
    
    const history = useHistory()
   

    return (
        <div className="row">
            <div className="col-lg-12">
                <div className="card">
                    <div className="card-body">
                        <form className="control-form">
                        <div className="row">
                        <div className="mb-3 col-6">
                                    <label className="form-label">Customer Name</label>
                                    <input
                                        className='form-control' 
                                        placeholder="Enter Customer Name "
                                    />
                                   
                                </div>
                                <div className="mb-3 col-6">
                                    <label className="form-label">Mobile No.</label>
                                    <input
                                        className='form-control' 
                                        placeholder="Enter Mobile No "
                                    />
                                   
                                </div>
                                </div>
                                <div className="row">
                                <div className="mb-3 col-6">
                                    <label className="form-label">EMail Address</label>
                                    <input
                                        className='form-control' 
                                        placeholder="Enter EMail Address "
                                    />
                                   
                                </div>
                               
                                <div className="mb-3 col-6">
                                <label className="form-label" >Tourist/ Resident</label>
                                <Select>
                                <option>Select Type</option>
                                                        <option>Tourist</option>
                                                        <option>Resident</option>
                                                       
                                </Select>
                            </div>
                                </div>
                                <div className="row">
                                <div className="mb-3 col-6">
                                    <label className="form-label">Inquiry Category</label>
                                    <input
                                        className='form-control' 
                                        placeholder="Enter Inquiry Category "
                                    />
                                   
                                </div>
                                <div className="mb-3 col-6">
                                    <label className="form-label">Inquiry Date</label>
                                    <input
                                        className='form-control' 
                                        placeholder="Enter Inquiry Date "
                                        type="date"
                                    />
                                   
                                </div>
                                </div>
                                <div className="row">
                                <div className="mb-3 col-6">
                                    <label className="form-label">Quotation No</label>
                                    <input
                                        className='form-control' 
                                        placeholder="Enter Quotation No "
                                    />
                                   
                                </div>
                                <div className="mb-3 col-6">
                                    <label className="form-label">Customer Service Name</label>
                                    <input
                                        className='form-control' 
                                        placeholder="Enter Customer Service Name "
                                    />
                                   
                                </div>
                                </div>
                                <div className="row">
                                <div className="mb-3 col-6">
                                    <label className="form-label">Retailer Name</label>
                                    <input
                                        className='form-control' 
                                        placeholder="Enter Retailer Name"
                                    />
                                   
                                </div>
                                <div className="mb-3 col-6">
                                    <label className="form-label">Value of Goods</label>
                                    <input
                                        className='form-control' 
                                        placeholder="Enter Value of Goods "
                                    />
                                   
                                </div>
                                </div>
                                <div className="row">
                                <div className="mb-3 col-6">
                                    <label className="form-label">Origin</label>
                                    <input
                                        className='form-control' 
                                        placeholder="Enter Origin"
                                    />
                                   
                                </div>
                                <div className="mb-3 col-6">
                                <label className="form-label" >Destination</label>
                                <Select>
                                <option>Select city</option>
                                                        <option>indore</option>
                                                        <option>indore</option>
                                                        <option>indore</option>
                                                        <option>indore</option>
                                                        <option>indore</option>
                                                      
                                </Select>
                                
                            
                            </div>
                            </div>
                            <div className="row">
                                <div className="mb-3 col-6">
                                    <label className="form-label">Tentative Shipping Date</label>
                                    <input
                                    type="date"

                                        className='form-control' 
                                        placeholder="Enter Tentative Shipping Date "
                                    />
                                   
                                </div>
                                <div className="mb-3 col-6">
                                    <label className="form-label"> Item Code</label>
                                    <input
                                        className='form-control' 
                                        placeholder="Enter Item Code "
                                    />
                                   
                                </div>
                                </div>
                                <div className="row">
                                <div className="mb-3 col-6">
                                    <label className="form-label"> Promocode</label>
                                    <input
                                        className='form-control' 
                                        placeholder="Enter Promocode "
                                    />
                                   
                                </div>
                                <div className="mb-3 col-6">
                                    <label className="form-label">  Sales Person Name</label>
                                    <input
                                        className='form-control' 
                                        placeholder="Enter  Sales Person Name"
                                    />
                                   
                                </div>
                                </div>
                            {/* <div className="mb-3">
                                <label className="form-label" > Cargo Details</label>
                                <Select>
                                <option>Select city</option>
                                                        <option>indore</option>
                                                        <option>indore</option>
                                                        <option>indore</option>
                                                        <option>indore</option>
                                                        <option>indore</option>
                                                      
                                </Select>
                            </div> */}
                            <div className="mt-3 d-flex justify-content-between">
                                <button
                                    className="btn btn-danger w-sm waves-effect waves-light"
                                    type="button"
                                    onClick={() => history.goBack()}
                                >Back</button>
                                <button className="btn btn-primary w-sm waves-effect waves-light"
                                    type="button"
                                    onClick={() =>console.log("fdgfdg")}
                                >Submit</button>
                            </div>
                        </form>
                    </div>
                  
                </div>
            </div>
        </div>
    )
}
